import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import KeyFactorsSection from '@/v2/components/sections/common/key-factors-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  additionalBenefitsSectionContent,
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  keyFactorsSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionSectionContent,
  whatSetsUsApartSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/dorm-room-storage-page'

interface DormRoomStoragePageProps {}

const DormRoomStoragePage: React.FC<DormRoomStoragePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
      w-[324px] h-[218px] 
      md-mn:w-[380px] md-mn:h-[286px] 
      lg:!w-[448px] lg:!h-[313px] 
      xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[383px] xl-min:!h-[50px] w-[322px] h-[44px]'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        className='xl-min:[&_button]:!w-[311px] [&_button]:w-[300px]'
        sectionTitleClassName='md-mn:w-full w-[90%]'
      />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...serviceTipsSectionSectionContent}
        sectionTitleClassName='md-mn:[&_p]:max-w-[550px] [&_p]:max-w-[90%]'
      />
      <KeyFactorsSection
        {...keyFactorsSectionContent}
        sectionTitleClassName='md-mn:w-full w-[90%]'
        imgClassName='w-[100px] h-[100px]'
        className='
            md-mn:[&_div>div:last-of-type]:gap-[38px]
            [&_div>div:last-of-type>article>div:first-of-type]:self-center
            md-mn:[&_article]:flex-row
            [&_article]:flex-col
            md-mn:[&_article]:text-left
            [&_article]:text-center
            md-mn:[&_article_p]:w-full
            md-mn:[&_article_p]:mx-0
            [&_article_p]:w-[90%]
            [&_article_p]:mx-auto
            '
      />
      <HelperSection
        isBgDark
        sectionTitleClassName='w-full'
        {...additionalBenefitsSectionContent}
        imgClassName='
            xl-min:!w-[618px] 
            xl-min:!h-[387px]
            md-mn:w-[450px] 
            md-mn:h-[252px] 
            w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            xl-min:[&_ul]:w-full
            xl-min:[&>div>div:last-of-type>div]:!flex-row
            [&>div>div:last-of-type>div]:flex-col
            `}
      />
      <HelperSection
        {...whatSetsUsApartSectionContent}
        imgClassName='
            xl-min:!w-[618px] 
            xl-min:!h-[387px]
            md-mn:w-[450px] 
            md-mn:h-[252px] 
            w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            xl-min:[&_ul]:w-full
            xl-min:[&>div>div:last-of-type>div]:!flex-row-reverse
            [&>div>div:last-of-type>div]:flex-col
            `}
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          xl-min:[&_h3]:!w-[80%]
          xl-min:[&_button]:!w-[242px]
          md-mn:[&_button]:w-[281px]
          [&_button]:w-[280px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} sectionTitleClassName='md-mn:w-full w-[80%]' />
    </>
  )
}

export default DormRoomStoragePage
